import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'cpfcnpj',
  pure: true,
})
export class CpfCnpjPipe implements PipeTransform {

  transform(cpfcnpj: unknown, ...args: string[]): string {
    if (!cpfcnpj) {
      return '-';
    }
    let val = `${cpfcnpj}`.replace(/[^0-9]/g, '');
    const size = val.length;
    val = '0'.repeat((size < 12 ? 11 : 14) - size) + val;
    if (size < 12) {
      return val.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return val.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

}
